<template>
  <v-container fluid>
    <v-card class="sv-card">
      <v-row no-gutters>
        <v-col cols="12">
          <v-tabs v-model="tab" class="sv-tabs">
            <v-tab
              v-for="tabItem in tabs"
              :key="tabItem.id"
              :to="{ name: 'UserDicsList', params: { dicId: tabItem.id } }"
              exact-path
            >
              {{ tabItem.title }}
            </v-tab>
          </v-tabs>
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      tab: 0,
      tabs: [],
      loading: true
    };
  },
  mounted() {
    this.tabs = this.$store.getters.getDicNames
      .filter(dicName => dicName.readonly == 0)
      .sort((a, b) => a.id - b.id);
  },
  beforeUpdate() {
    this.checkRoute();
  },
  methods: {
    checkRoute() {
      if (this.$router.currentRoute.name == "UserDics") {
        if (this.tabs.length > 0) {
          const tab = this.tabs[0];
          this.$router.push({
            name: "UserDicsList",
            params: { dicId: tab.id }
          });
        }
      }
    }
  }
};
</script>
